module.exports = __webpack_public_path__ + "img/appMonitor.0c783b0b.png";